{
  "schemaVersion": 1,
  "id": "image-resizer",
  "version": "1.0.0",
  "name": "Image Resizer",
  "description": "Resize photos with a visual before-and-after comparison.",
  "categories": ["Images", "Files"],
  "icon": "image",
  "script": "run.mjs",
  "interface": {
    "type": "html",
    "entry": "ui.html"
  },
  "requiredExecutables": []
}
